import React, { useState, Fragment, useEffect } from "react";
import {
    Row,
    Input,
    Label,
    Button,
    ButtonGroup,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Card,
    CardBody,
    CardHeader,
    CardFooter
} from "reactstrap";
import { Colxx } from "../../../../../../components/common/CustomBootstrap";
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
    putAPI_Update_OutboundTrigger,
    deleteAPI_Delete_OutboundTrigger
} from '../../../../../../constants/APIs';
import Triggers from '../../../../../../data/Triggers';
import country from '../../../../../../data/country';
import { TriggerForm } from './TriggerForm';
import { TriggerAction } from "./TriggerAction";

export function TriggerList({ item, index, LoadData, propertyId }) {
    const triggerId = item.id;
    const [isEdit, setIsEdit] = useState(false);
    const [isDeleteVisible, setIsDeleteVisible] = useState(false);
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(false);
    const [isActionVisible, setIsActionVisible] = useState(false);

    useEffect(() => {
        if (item.status === "Active") {
            setCheckedPrimarySmall(true);
        }
        else {
            setCheckedPrimarySmall(false);
        }
    }, [item]);
    const handleSwitchChange = (value) => {
        setCheckedPrimarySmall(value);
        handleOnOff(value);
    };
    const handleOnOff = (onoff) => {
        const body = {
            status: onoff === false ? "Inactive" : "Active",
            updator: "dashboard"
        }
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_OutboundTrigger}/${item.id}/status`,
            data: body,
        }).then((res) => {
            LoadData();
        });
    }
    const formatTime = (dateTime) => {
        if (!dateTime) return "";
        return dateTime.substring(11, 16); // HH:mm
    };
    const toggleDelete = () => {
        setIsDeleteVisible(!isDeleteVisible);
    }
    const handleDeleteTrigger = () => {
        const body = {
            deleter: "dashboard"
        }
        AxiosAPI({
            method: 'delete',
            url: `${deleteAPI_Delete_OutboundTrigger}/${item.id}`,
            data: body,
        }).then((res) => {
            toggleDelete();
            LoadData();
        });
    };
    const generateDeletePopup = () => {
        return (
            <Fragment>
                <Modal isOpen={isDeleteVisible} toggle={toggleDelete}>
                    <ModalHeader toggle={toggleDelete}>
                        <span role="img" aria-label="warning">
                            ⚠️
                        </span>
                        This will be delete trigger.
                    </ModalHeader>
                    <ModalBody>
                        <Button
                            color="danger"
                            onClick={() => handleDeleteTrigger()}
                            size="xs"
                        >
                            Delete
                        </Button>
                        <Button
                            className="ml-2"
                            color="dark"
                            outline
                            size="xs"
                            onClick={toggleDelete}
                        >
                            Cancel
                        </Button>
                    </ModalBody>
                </Modal>
            </Fragment>
        );
    };
    return (
        <Fragment>
            {isEdit ? (
                <TriggerForm
                    visible={isEdit}
                    toggle={() => setIsEdit(!isEdit)}
                    formLabel={"Update"}
                    propertyId={propertyId}
                    LoadData={LoadData}
                    triggerId={triggerId}></TriggerForm>
            ) : (
                <div key={index} className="col-item mb-4 col-md-3 col-lg-4">
                    <div className="card  border-radius-trigger">
                        <div className="pt-5 pb-5 d-flex flex-lg-column flex-md-row flex-sm-row flex-column card-body">
                            <div>
                                <Switch
                                    className="agentswitch custom-switch-primary custom-switch-small integrationremove"
                                    checked={checkedPrimarySmall}
                                    onChange={(primary) => handleSwitchChange(primary)}
                                />
                            </div>
                            <div className="price-top-part">
                                <h5 className="mb-0 font-weight-semibold color-theme-1 mb-1">{item.triggerName}</h5>
                            </div>
                            <div className="pl-3 pr-3 pb-0 d-flex price-feature-list flex-column flex-grow-1">
                                <ul className="list-unstyled">
                                    {item.trigger.map((con, i) => (
                                        <li key={i}>
                                            {con.operator !== "" && " " + con.operator}{" "}
                                            {Triggers.filter((i) => i.value === con.text).map((elem) => elem.label)}
                                            {con.text === "member_birthday" && (
                                                <p className="mb-0 text-muted">
                                                    Send at {formatTime(item.scheduleTime)}
                                                </p>
                                            )}

                                            {con.text === "member_joining_date" && (
                                                <p className="mb-0 text-muted">
                                                    Send a message {con.daysMinutes?.text}{" "}
                                                    {con.daysMinutes?.type === "Days"
                                                        ? (con.daysMinutes?.text === "1" ? "Day" : "Days")
                                                        : (con.daysMinutes?.text === "1" ? "Minute" : "Minutes")}
                                                    {" "}after joining date
                                                    {item.scheduleTime && ` at ${formatTime(item.scheduleTime)}`}
                                                </p>
                                            )}

                                            {con.text !== "member_birthday" &&
                                                con.text !== "member_joining_date" &&
                                                con.daysMinutes !== null &&
                                                con.daysMinutes.text !== "0" && (
                                                    <p className="mb-0 text-muted">
                                                        Send a message {con.daysMinutes.text}{" "}
                                                        {con.daysMinutes.type === "0" ? "" : con.daysMinutes.type}{" "}
                                                        {con.text === "guest_upcoming_booking" && "before check-in"}{" "}
                                                        {con.text === "guest_checked_in" && "after check-in"}{" "}
                                                        {con.text === "guest_checked_out" && "after check-out"}{" "}
                                                    </p>
                                                )}
                                            {con.tags && con.tags.length > 0 && (
                                                <p className="mb-0 text-muted">
                                                    ({con.tags.map((tag, index) => (
                                                        <Fragment key={index}>
                                                            {tag} {index < con.tags.length - 1 && ","}
                                                        </Fragment>
                                                    ))})
                                                </p>
                                            )}
                                            {con.text === "guest_country" && con.country && con.country.length > 0 && (
                                                <p className="mb-0 text-muted">
                                                    ({con.country.map((i, index) => (
                                                        <Fragment key={index}>
                                                            {i.name}{index < con.country.length - 1 && ", "}
                                                        </Fragment>
                                                    ))})
                                                </p>
                                            )}
                                            {con.text === "guest_length_stay" && con.stayLength !== "" && (
                                                <p className="mb-0 text-muted">{con.stayLength}</p>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                                {item.actions && item.actions.length > 0 && (
                                    <Fragment>
                                        <div className="mb-3">
                                            <p className="text-center mb-2">
                                                <strong>TRIGGER ACTIONS</strong>
                                            </p>

                                            <p className="color-theme-1 text-center">
                                                {item.actions
                                                    .map(act => `Priority: ${act.priority} - ${act.channel === 'PhoneSuite' ? 'Voice Call' : act.channel}`)
                                                    .join(", ")}
                                            </p>
                                        </div>
                                    </Fragment>
                                )}

                                <div className="text-center">
                                    <ButtonGroup className="mb-2">
                                        <Button
                                            size="xs"
                                            color="primary"
                                            outline
                                            onClick={() => setIsEdit(!isEdit)}
                                        >
                                            Edit
                                        </Button>
                                        <Button
                                            size="xs"
                                            color="danger"
                                            outline
                                            onClick={() => toggleDelete()}
                                        >
                                            Delete
                                        </Button>
                                        <Button
                                            size="xs"
                                            color="secondary"
                                            outline
                                            onClick={() => setIsActionVisible(!isActionVisible)}
                                        >
                                            + Actions
                                        </Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {isActionVisible ?
                <TriggerAction
                    visible={isActionVisible}
                    toggle={() => setIsActionVisible(!isActionVisible)}
                    propertyId={propertyId}
                    LoadData={LoadData}
                    triggerId={triggerId}
                    triggerStatus={item.status}></TriggerAction>
                : null
            }
            {generateDeletePopup()}
        </Fragment >
    );
};